const ActionTypes = {
  ADD_TEMPLATES: 'ADD_TEMPLATES',
  SET_DEFAULT_TEMPLATE: 'SET_DEFAULT_TEMPLATE',
  SET_LAST_USED_TEMPLATE: 'SET_LAST_USED_TEMPLATE',
};

module.exports = {
  ActionTypes,
};
